export default {"src":"/_next/static/image/src/images/Footer/pinterest.58583b53bdf2399ab27cd20ce5ca995c.svg","height":20,"width":18};